import { t } from 'i18next';
import { ObjectSchema } from 'yup';
import Yup from '../../../services/common/validation';
import { AddressFormModel_MX } from './formModel';

export const getValidationSchema = (isConsumerOrSoleTrader: boolean): ObjectSchema<Partial<AddressFormModel_MX>> => {
  const shouldBeEmptySchema = Yup.string().shouldBeEmpty();

  return Yup.object({
    addressLine1: Yup.string()
      .matches(/^[a-zA-Z0-9 ]*$/, t('validation:onlyLettersAndNumbers'))
      .required(t('validation:required')),
    addressLine2: Yup.string()
      .matches(/^[a-zA-Z0-9 ]*$/, t('validation:onlyLettersAndNumbers'))
      .notRequired(),
    addressLine3: Yup.string()
      .matches(/^[a-zA-Z0-9 ]*$/, t('validation:onlyLettersAndNumbers'))
      .notRequired(),
    eirCode: Yup.string().eirCode(t('validation:invalidEircode')).required(t('validation:required')),
    town: Yup.string()
      .matches(/^[a-zA-Z0-9 ]*$/, t('validation:onlyLettersAndNumbers'))
      .required(t('validation:required')),
    county: Yup.string().required(t('validation:required')),
    residentialStatus: isConsumerOrSoleTrader ? Yup.string().required(t('validation:required')) : shouldBeEmptySchema,
    timeAtAddressFrom: isConsumerOrSoleTrader ? Yup.string().required(t('validation:required')) : shouldBeEmptySchema,
    timeAtAddressTo: isConsumerOrSoleTrader ? Yup.string().required(t('validation:required')) : shouldBeEmptySchema,
  });
};
